import { Model } from "@rematch/core";
import { IApplication } from "shared/model/IApplication";
import {
  ICoworkGeoLocation,
  IGooglePlace
} from "shared/model/ICoworkGeoLocation";
import {
  IMemberBotPageParams,
  MemberBotType
} from "shared/pages/MembersBotPage";
import { CreateFollowupType } from "shared/functions/createFollowupJob";

import { PlaidAuthenticationData } from "../../../components/PlaidAuthenticator/PlaidAuthenticator";
import { IRefreshablePropSubState } from "../../model/SharedTypes";
import { StateModules } from "../types";
import { IState } from "./..";
import { ILandbotProps } from "./MemberChatLandbotProps";
import {
  createFollowupJob,
  initMemberSession,
  refreshApplication,
  stopRefreshingApplication,
  updateApplicationPlaidAuth,
  updateSelectedPlace
} from "./MembersChatEffetcs";

export interface IMembersChatModel extends Model {
  name: StateModules;
  state: IMembersChatState;
  reducers: IMembersChatReducers;
  effects: IMembersChatEffects;
}

export type IMembersChatState = {
  coworkName?: string;
  applicationId?: string;
  application: IRefreshablePropSubState<IApplication>;
  botType?: MemberBotType;
  botProps: ILandbotProps;
  selectedPlaceLocation?: ICoworkGeoLocation;
};

export type IMembersChatReducers = {
  setBotData: (
    state: IMembersChatState,
    params: { type: MemberBotType; props: ILandbotProps }
  ) => IMembersChatState;
  setApplicationId: (
    state: IMembersChatState,
    params: { id: string }
  ) => IMembersChatState;
  setCoworkLocation: (
    state: IMembersChatState,
    params: { location: ICoworkGeoLocation }
  ) => IMembersChatState;
  fetchingApplication: (
    state: IMembersChatState,
    params: {}
  ) => IMembersChatState;
  applicationFetchSuccess: (
    state: IMembersChatState,
    params: {
      application: IApplication;
      coworkName?: string;
      applicationId: string;
    }
  ) => IMembersChatState;
  applicationFetchError: (
    state: IMembersChatState,
    params: { error: string }
  ) => IMembersChatState;
};

export type IMembersChatEffects = {
  initMemberSession: (params: IMemberBotPageParams, state: IState) => void;
  updateApplicationPlaidAuth: (
    params: { data: PlaidAuthenticationData },
    state: IState
  ) => void;

  createFollowupJob: (
    params: { type: CreateFollowupType },
    state: IState
  ) => void;

  updateSelectedPlace: (
    params: { place: IGooglePlace | string | undefined },
    state: IState
  ) => void;

  refreshApplication: (params: {}, state: IState) => void;
  stopRefreshingApplication: (params: {}, state: IState) => void;
};

export type IMembersChatDispatch = {
  setBotData: (params: {
    type: MemberBotType;
    props: ILandbotProps;
  }) => IMembersChatState;
  setApplicationId: (params: { id: string }) => void;
  setCoworkLocation: (params: { location: ICoworkGeoLocation }) => void;
  fetchingApplication: () => void;
  applicationFetchSuccess: (params: {
    application: IApplication;
    coworkName?: string;
    applicationId: string;
  }) => void;
  applicationFetchError: (params: { error: string }) => void;

  initMemberSession: (params: IMemberBotPageParams) => void;
  updateApplicationPlaidAuth: (params: {
    data: PlaidAuthenticationData;
  }) => void;

  createFollowupJob: (params: { type: CreateFollowupType }) => void;

  updateSelectedPlace: (params: {
    place: IGooglePlace | string | undefined;
  }) => void;

  refreshApplication: () => void;
  stopRefreshingApplication: () => void;
};

export const MembersChatModule: IMembersChatModel = {
  name: "membersChat",
  state: {
    application: { isFetching: false },
    botProps: {}
  },
  reducers: {
    setBotData: (
      state: IMembersChatState,
      params: { type: MemberBotType; props: ILandbotProps }
    ): IMembersChatState => ({
      ...state,
      botType: params.type,
      botProps: params.props
    }),
    setApplicationId: (
      state: IMembersChatState,
      params: { id: string }
    ): IMembersChatState => ({
      ...state,
      applicationId: params.id
    }),
    setCoworkLocation: (
      state: IMembersChatState,
      params: { location: ICoworkGeoLocation }
    ): IMembersChatState => ({
      ...state,
      selectedPlaceLocation: params.location,
      coworkName: params.location.coworkName
    }),
    fetchingApplication: (
      state: IMembersChatState,
      params: {}
    ): IMembersChatState => ({
      ...state,
      application: {
        isFetching: true,
        error: undefined
      }
    }),
    applicationFetchSuccess: (
      state: IMembersChatState,
      params: {
        application: IApplication;
        coworkName?: string;
        applicationId: string;
      }
    ): IMembersChatState => ({
      ...state,
      coworkName: params.coworkName,
      application: {
        isFetching: false,
        prop: params.application
      },
      applicationId: params.applicationId
    }),
    applicationFetchError: (
      state: IMembersChatState,
      params: { error: string }
    ): IMembersChatState => ({
      ...state,
      application: {
        isFetching: false,
        error: params.error
      }
    })
  },
  effects: {
    initMemberSession,
    updateApplicationPlaidAuth,
    updateSelectedPlace,
    refreshApplication,
    stopRefreshingApplication,
    createFollowupJob
  }
};



// WEBPACK FOOTER //
// ./src/state/modules/membersChat/MembersChatModule.ts